import * as contUrl from '../../const';
import http from '../../utils/http';
import cookie from '../../utils/cookie.js';
export default {
	namespaced: true,
	state: {
		cartNum: 0,
	},
	getters: {

	},
	mutations: {

		getCartINFO(state, data) {
			let shopNum = 0;
			data.forEach((item, i) => {
				shopNum = shopNum + item.items.length;
			});
			state.cartNum = shopNum;
		},
	},
	actions: {

		getCartINFO({ commit }, data) {
			// 用户购物车数据
			return new Promise((resolve, reject) => {
				http.get(contUrl.common.getShoppingCart, '', true).then(res => {
					// 请求成功
					commit('getCartINFO', res.data);
					// 如果是一个请求，更改多个state里面的数据，就调用mutations对应的修改方法～
					resolve() // 通知组件，接口调用成功了
				}).catch(err => {
					reject(err) // 通知组件，接口调用失败，并把失败原因传过去
				})
			})
		},
	}
}